// @flow
import { merge } from 'lodash';
import theme from 'app/theme';

export function linearGradient(...args: Array<*>) {
  const argStr = args.join(', ');
  return `linear-gradient(${argStr})`;
}

export function diagonalGradient(
  firstColor: string,
  secondColor: string,
  xPos: string = 'right',
  yPos: string = 'bottom',
) {
  // 49% to prevent the jaggyness that occurs with 50% -> 50% in chrome
  return `linear-gradient(to ${xPos} ${yPos}, ${firstColor} 49%, ${secondColor} 50%)`;
}

export function mediaQuery(minWidth: number, maxWidth: number, options: Object = {}) {
  const { units = 'px' } = options;

  if (minWidth && maxWidth) {
    return `@media (min-width: ${minWidth}${units}) and (max-width: ${maxWidth}${units})`;
  }
  if (minWidth) {
    return `@media (min-width: ${minWidth}${units})`;
  }
  if (maxWidth) {
    return `@media (max-width: ${maxWidth}${units})`;
  }

  return '@media all';
}

// hover on desktop / Tappable-active on mobile
export function hover(hoverStyle: Object) {
  return {
    '&:not(.disabled):not(:disabled)': {
      '&.Tappable-active': hoverStyle,
      '&:active': hoverStyle,
      [theme.mediaQuery.desktopAndUp]: {
        '&:hover': hoverStyle,
      },
    },
  };
}
